const isPupillaryDistance = (param)=>param.name === 'pupillaryDistance'
;

export { isPupillaryDistance };
//# sourceMappingURL=is-pupillary-distance.js.map
